import { Clickable, PartnerBox, TeamBox, Text } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Partners, Teams } from './';

const WebContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 100px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileContainer = styled.div`
  margin-top: 100px;
  width: 100vw;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    display: none;
  }
`;

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
`;

const BlackArea = styled.div`
  height: 308px;
  width: 100%;
  background-color: black;
  margin-top: -280px;
  z-index: -1;

  @media (max-width: 1024px) {
    margin-top: -282px;
    height: 306px;
  }
`;

const PartnerAndTeamContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-left: ${(props) => props.extraPad};
  scroll-behavior: smooth;

  @media (max-width: 1024px) {
    padding: 0 13px;
  }
`;

const GoToPartnersAndSponsors = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 1140px;
  align-self: center;
  margin-top: 33px;

  p {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 18px;
    margin-right: 13px;

    p {
      font-size: 16px;
    }
  }
`;

const PartnersAndTeams = ({ data }) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    newsRef = useRef(null),
    navigate = useNavigate(),
    { teams, partners } = data;

  const combinedData = [];
  for (var i = 0; i < Math.max(teams.length, partners.length); i++) {
    if (i < partners.length) combinedData.push({ ...partners[i], partner: true });
    if (i < teams.length) combinedData.push({ ...teams[i], teams: true });
  }

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  if (!combinedData.length) return null;
  return (
    <React.Fragment>
      <MobileContainer>
        <BackgroundContainer>
          <div
            id="partnerAndTeamScroll"
            style={{ paddingLeft: extraPad, overflowX: 'scroll', overflowY: 'hidden' }}
            ref={newsRef}
          >
            <PartnerAndTeamContainer>
              {combinedData.map((x, i) =>
                x.partner ? (
                  <PartnerBox mobileMode marg="0 30px 0 0" item={x} key={i} />
                ) : (
                  <TeamBox mobileMode marg="0 30px 0 0" item={x} key={i} />
                )
              )}
            </PartnerAndTeamContainer>
          </div>

          <BlackArea />
        </BackgroundContainer>

        <GoToPartnersAndSponsors>
          <Clickable onClick={() => navigate('/partners-and-sponsors')}>
            <Text>
              {t('website.goto')} <b>{t('website.partnersAndSponsors')}</b>
            </Text>
          </Clickable>
        </GoToPartnersAndSponsors>
      </MobileContainer>

      <WebContainer>
        <Partners data={partners} />
        <Teams data={teams} />
      </WebContainer>
    </React.Fragment>
  );
};

export default PartnersAndTeams;
